import { render } from "./InscricaoForm.vue?vue&type=template&id=73f9c9b0&scoped=true"
import script from "./InscricaoForm.vue?vue&type=script&lang=js"
export * from "./InscricaoForm.vue?vue&type=script&lang=js"

import "./InscricaoForm.vue?vue&type=style&index=0&id=73f9c9b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f9c9b0"]])

export default __exports__